import { createSlice } from '@reduxjs/toolkit';
import { LISTING_INITIAL_STATE } from 'src/components/VendorPortal/ListingLayout/shared/constants';
import reducers from 'src/redux/vendor-portal/work-order/reducers';
import {
  WO_DETAILS_TABS_KEYS,
  WO_SORT_DEFAULT,
  WO_TAB_FILTERS,
  WO_TABS_KEYS,
} from 'src/views/VendorPortal/WorkOrder/constants';
import { WO_CLOSE_WORK_ORDER_TABS_KEYS } from 'src/views/VendorPortal/WorkOrder/SidePanel/CloseWorkOrder/constants';
import extraReducers from './extra-reducers';
import type { WorkOrderDataType, WorkOrderIssueType, WorkOrderStateType } from './types';

const workOrderInitialState: WorkOrderStateType = {
  ...LISTING_INITIAL_STATE,
  categoryOptions: [],
  currentListingTab: WO_TABS_KEYS.OPEN,
  data: [],
  source: {} as WorkOrderDataType,
  filters: {
    status: WO_TAB_FILTERS[WO_TABS_KEYS.OPEN],
    category: [''],
    closed_date: [''],
    paused_date: [''],
    scheduled_date: [''],
  },
  sortBy: WO_SORT_DEFAULT[WO_TABS_KEYS.OPEN],
  tabCounts: {
    open: 0,
    paused: 0,
    closed: 0,
  },
  sidePanels: {
    details: {
      areAllIssuesMarked: false,
      currentTab: WO_DETAILS_TABS_KEYS.DETAILS,
      isClosingWO: false,
      isLoading: false,
      isStatusLoading: false,
      isOpen: false,
      needToRefetch: false,
      showIssuesWarning: false,
      hasDetailsError: false,
    },
    issueDetails: {
      isLoading: false,
      isOpen: false,
    },
    successWorkOrder: {
      isOpen: false,
    },
    reschedule: {
      accessIssueReason: null,
      isFormLoading: false,
      isFormValid: false,
      isOpen: false,
      isLoading: false,
      reason: null,
    },
    markUnResolve: {
      isFormLoading: false,
      isFormValid: false,
      isOpen: false,
      isEdit: false,
    },
    closeWorkOrder: {
      currentTab: WO_CLOSE_WORK_ORDER_TABS_KEYS.SUMMARY,
      isLoading: false,
      isOpen: false,
    },
    cancelWO: {
      isOpen: false,
      steps: { key: '', step: '1' },
    },
    quoteDetails: {
      isOpen: false,
      isLoading: false,
      loadingAction: '',
    },
    scheduleReturnTrip: {
      isOpen: false,
      isFormValid: false,
      isFormLoading: false,
    },
    quoteTaskDetails: {
      isOpen: false,
      isFormValid: false,
      isLoading: false,
      mode: 'view',
      noIssue: false,
      options: [],
      taskId: '',
      taskType: 'standard',
      title: '',
    },
    quoteApprovedTaskDetails: {
      isOpen: false,
      isFormValid: false,
      isLoading: false,
      mode: 'view',
      options: [],
      taskId: '',
      taskType: 'standard',
      title: '',
      issue: {} as WorkOrderIssueType,
    },
    messages: {
      isOpen: false,
      isLoading: false,
    },
    tripSummary: {
      isOpen: false,
      isLoading: false,
      tripId: undefined,
    },
  },
};

const workOrderSlice = createSlice({
  name: 'workOrder',
  initialState: workOrderInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  clearWorkOrderListFilters,
  changeWorkOrderTab,
  filterWorkOrderList,
  searchWorkOrderList,
  setWOFilterMapping,
  setWOSortMapping,
  setWOTableMapping,
  // setListingController,
  sortWorkOrderList,
  openWODetailsSidePanel,
  closeWODetailsSidePanel,
  openIssueDetailsSidePanel,
  closeIssueDetailsSidePanel,
  updateIssueDetailsQuoteTaskOptions,
  openCloseWorkOrderSidePanel,
  closeCloseWorkOrderSidePanel,
  updateCloseWorkOrderSidePanel,
  updateCloseWorkOrderTabSidePanel,
  changeWODetailsTab,
  updateVendorWorkOrderDetails,
  updateRescheduleSidePanel,
  updateVendorSidePanel,
  updateWorkOrderDetails,
  updateWorkOrderTrip,
  updateWorkOrderStatusInList,
  setIssuesWarning,
  toggleCancelWOSidePanel,
  updateCancelWOSidePanelStep,
  backToRescheduleSidePanel,
  backToDetailsSidePanel,
  markUnresolveDetailsSidePanel,
  editmarkUnresolveDetailsSidePanel,
  closemarkUnresolveDetailsSidePanel,
  updateWorkOrderIssueStatusDetailsSidePanel,
  updateWorkOrderIssueQualityCheckStatus,
  editQuoteDetails,
  removeQuoteTaskFromQuote,
  addQuoteTaskDetails,
  editQuoteTaskDetails,
  viewQuoteTaskDetails,
  viewApprovedQuoteTaskDetails,
  openMessagesSidePanel,
  closeMessagesSidePanel,
  updateWorkOrderQuotes,
  updateWorkOrderList,
  updateWorkOrderUnreadMessagesCount,
  clearWorkOrderUnreadMessagesCount,
  openTripSummarySidePanel,
  closeTripSummarySidePanel,
  removeIssueMedia,
} = workOrderSlice.actions;

export default workOrderSlice.reducer;
